/* eslint-disable n/no-process-env */
export default Object.freeze({
  NODE_ENV: process.env.NODE_ENV,
  PUBLIC_URL: process.env.PUBLIC_URL,
  API_HOST: process.env.REACT_APP_API_HOST ?? 'https://dapi.aivatar.ai',
})
